export const DashboardMenuItemTooltip: React.FC<{
  label: string;
  isVisible: boolean;
}> = ({ label, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 bg-slate-800 text-white px-3 py-2 rounded-lg text-sm font-medium shadow-xl z-50 whitespace-nowrap">
      {label}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1 w-2 h-2 bg-slate-800 rotate-45" />
    </div>
  );
};
